import { DocumentMarkersMode } from "../pdf-utils/enums";
import { EpubAnnotationMode } from "./enums";

export function mapToEpubAnnotationMode(mode: DocumentMarkersMode): EpubAnnotationMode {
    switch (mode) {
        case DocumentMarkersMode.Marker:
            return EpubAnnotationMode.Marker;
        case DocumentMarkersMode.Eraser:
            return EpubAnnotationMode.Eraser;
        default:
            return EpubAnnotationMode.None;
    }
}